import React from 'react';
import Layout from '../components/Layout';

const pressLinks = [
  { title: 'British Vogue', href: 'https://www.vogue.co.uk/article/the-best-shopping-destinations-in-london?fbclid=PAQ0xDSwMaT_JleHRuA2FlbQIxMQABpz8L-48x7fs7oJIbp4j_g3KO-fNiMBmrv_XGcQIC_IvHqjH2QNUiEZuOLz4c_aem_fRPuqbSjQQR4JEP7mvZ28Q' },
  { title: 'i-D', href: 'https://www.instagram.com/p/DIZA7YQNtaI/?hl=en&img_index=1' },
  { title: 'ShowStudio', href: 'https://www.instagram.com/p/DIRepXhtbQ2/?hl=en&img_index=1' },
  { title: 'Hypebae', href: 'https://hypebae.com/2025/7/this-belongs-to-white-bandera-collection-campaign' },
  { title: 'Metal Mag', href: 'https://metalmagazine.eu/en/post/this-belongs-to' },
  { title: 'New York Magazine', href: 'https://nymag.com/strategist/article/best-womens-underwear.html' },
  { title: 'Because Magazine', href: 'https://becauselondon.com/articles/fashion/2024/this-belongs-to/' },
];

function Press() {
  window.scrollTo(0, 0);

  return (
    <Layout>
      <div className="py-12">
        <h1 className="text-3xl italic mb-10 text-center">Press</h1>

        <ul
          role="list"
          className="max-w-3xl mx-auto px-4 md:px-0 text-center"
        >
          {pressLinks.map(({ title, href }, i) => (
            <li key={i} className="my-6">
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  italic text-customNavy
                  text-lg md:text-lg
                  hover:underline
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customNavy
                "
              >
                {title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}

export default Press;
